import Button from '@mui/material/Button';
import React from 'react';

const TextButton = React.forwardRef((props, ref) => {
  return (
    <Button
      variant="text"
      disableRipple
      ref={ref}
      {...props}
      sx={{
        typography: 'body2',
        fontSize: '1em',
        p: 0,
        minWidth: 0,
        borderRadius: 0,
        color: 'text.primary',
        textTransform: 'none',
        lineHeight: 'inherit',
        backgroundColor: 'transparent',
        '&:hover': theme => ({
          backgroundColor: 'transparent',
          textDecoration: 'underline',
          color: `${theme.palette.primary.main}`,
        }),
        '&:focusVisible': theme => ({
          outline: `2px solid ${theme.palette.primary.main}`,
          outlineOffset: 2,
        }),
        '&.Mui-disabled': { color: 'text.disabled' },
        ...(props.sx || {}),
      }}
    />
  );
});

export default TextButton;
